module.exports = __webpack_public_path__ + "img/7_113.39b2cbdd.png";